module.exports = __webpack_public_path__ + "static/media/ic.246b78d4.svg";